export default "__VITE_ASSET__DMwpSYVp__"